import React, { useState, useEffect } from 'react';
import LazyLoad from "react-lazyload";
import axios from 'axios';


    const TestimonialSection = ({ cityName, BASE_URL, INVITES_API }) => {

    const [testimonialsData, setTestimonialData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentSlide, setCurrentSlide] = useState(0);
    const APIURL = `${INVITES_API}api`


    useEffect(() => {
        const controller = new AbortController(); // Create an abort controller
      
        const fetchTestimonials = async () => {
          try {
            const response = await axios.post(
              `${APIURL}/city-page/getTestimonials`,
              { pageType: "home" },
              { signal: controller.signal } // ✅ Hook it up here
            );
            
            setTestimonialData(response.data.data); // assuming response shape is { success, data }
          } catch (error) {
            if (axios.isCancel(error)) {
              console.log("Request cancelled:", error.message);
            } else {
              console.error("Error fetching Testimonials:", error);
            }
          } finally {
            setIsLoading(false);
          }
        };
      
        fetchTestimonials();
      
        return () => {
          controller.abort(); // Cancel the request if component unmounts
        };
      }, []);
      

      const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
      };

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % testimonialsData.length);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + testimonialsData.length) % testimonialsData.length);
    };

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    return ( 
        <>
        { isLoading || testimonialsData.length === 0 ? (
            ""
        ) : (
            <>
            <section className="testimonial-section">
                <div className="testimonial-container">
                    <h2 className="testimonial-title">What Our Customers have to Say</h2>
                    <h3 className="testimonial-subtitle">Video Testimonial of {cityName}</h3>

                    <div className="testimonial-carousel">
                    <div className="testimonial-content">
                        <div className="testimonial-image-container">
                        { testimonialsData[currentSlide]?.image_src == null || testimonialsData[currentSlide]?.image_src === "0" ? (
                            
                            <LazyLoad height={313}>
                                <video
                                key={currentSlide} // 🔥 This forces the video to re-render
                                width="585px"
                                height="313px"
                                controls
                                >
                                    <source src={testimonialsData[currentSlide].video_src} type="video/mp4" />
                                </video>
                            </LazyLoad> 
                        ) : (
                            <img 
                                src={testimonialsData[currentSlide]?.image_src} 
                                alt="Customer Testimonial"
                                className="testimonial-image"
                            /> 
                        )}

                        <div className="navigation-container">
                            <button 
                            className="nav-button" 
                            onClick={prevSlide}
                            aria-label="Previous testimonial"
                            >
                                <img
                                    src="../../media/solar_arrow-left-linear.svg"
                                    alt="bk icon"
                                    loading="lazy"
                                />
                            </button>
                            <div className="testimonial-dots">
                            {testimonialsData.map((_, index) => (
                                <button
                                key={index}
                                className={`dot ${currentSlide === index ? 'active' : ''}`}
                                onClick={() => goToSlide(index)}
                                aria-label={`Go to testimonial ${index + 1}`}
                                />
                            ))}
                            </div>
                            <button 
                            className="nav-button" 
                            onClick={nextSlide}
                            aria-label="Next testimonial"
                            >
                            <img
                                src="../../media/solar_arrow-right-linear.svg"
                                alt="bk icon"
                                loading="lazy"
                            />
                            </button>
                        </div>
                        </div>
                        <div className="testimonial-quote-container">
                            <div className="quote-mark quote-mark-start">
                                <div className="quote-mark-icon">
                                    <img
                                    src="../../media/double-quotes-start.svg"
                                    alt="bk icon"
                                    loading="lazy"
                                    />
                                </div>
                            </div>
                            <p className="testimonial-quote">
                                {testimonialsData[currentSlide]?.comments}
                            </p>
                            <h4 className="testimonial-event-name">
                                {testimonialsData[currentSlide]?.title}
                            </h4>
                            <div className="quote-mark quote-mark-end">
                                
                                <img
                                    src="../../media/double-quotes-end.svg"
                                    alt="bk icon"
                                    loading="lazy"
                                />
                                
                            </div>
                        </div>
                    </div>
                    </div>

                    <div className="testimonial-carousel-mobile" >
                        <div className="testimonial-content">
                            <div className="testimonial-image-container">
                                <div className="testimonial-image-mobile" >
                                    
                                    { testimonialsData[currentSlide]?.image_src == null || testimonialsData[currentSlide]?.image_src === "0" ? (
                            
                                        <LazyLoad height={175}>
                                            <video  key={currentSlide}  width="327px" height="175px" controls>
                                                <source src={testimonialsData[currentSlide]?.video_src} type="video/mp4"></source>
                                            </video>
                                        </LazyLoad> 
                                    ) : (
                                        <img 
                                            src={testimonialsData[currentSlide]?.image_src} 
                                            alt="Customer Testimonial"
                                            className="testimonial-image"
                                        /> 
                                    )}
                                </div>
                                <div className="testimonial-quote-container">
                                <h4 className="testimonial-event-name-mobile">
                                    {testimonialsData[currentSlide]?.title}
                                </h4>
                                <div className="quote-mark quote-mark-start">
                                    <div className="quote-mark-icon">
                                        <img
                                        src="../../media/double-quotes-start.svg"
                                        alt="bk icon"
                                        width={16}
                                        height={16}
                                        loading="lazy"
                                        />
                                    </div>
                                </div>
                                <p className="testimonial-quote">
                                    {testimonialsData[currentSlide]?.comments}
                                </p>
                                <div className="quote-mark quote-mark-end">
                                    
                                    <img
                                        src="../../media/double-quotes-end.svg"
                                        alt="bk icon"
                                        width={16}
                                        height={16}
                                        loading="lazy"
                                    />
                                    
                                </div>
                            </div>
                            <div className="navigation-container">
                                <button 
                                className="nav-button" 
                                onClick={prevSlide}
                                aria-label="Previous testimonial"
                                >
                                    <img
                                        src="../../media/solar_arrow-left-linear.svg"
                                        alt="bk icon"
                                        loading="lazy"
                                    />
                                </button>
                                <div className="testimonial-dots">
                                {testimonialsData
                                    .slice(
                                    Math.max(0, Math.min(currentSlide - 2, testimonialsData.length - 4)),
                                    Math.max(4, Math.min(currentSlide + 2, testimonialsData.length))
                                    )
                                    .map((_, index) => {
                                    // Actual index in original array
                                    const actualIndex = Math.max(0, Math.min(currentSlide - 2, testimonialsData.length - 4)) + index;
                                    return (
                                        <button
                                        key={actualIndex}
                                        className={`dot ${currentSlide === actualIndex ? 'active' : ''}`}
                                        onClick={() => goToSlide(actualIndex)}
                                        aria-label={`Go to testimonial ${actualIndex + 1}`}
                                        />
                                    );
                                    })}
                                </div>

                                <button 
                                className="nav-button" 
                                onClick={nextSlide}
                                aria-label="Next testimonial"
                                >
                                <img
                                    src="../../media/solar_arrow-right-linear.svg"
                                    alt="bk icon"
                                    loading="lazy"
                                />
                                </button>
                            </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </section>
            </>
        ) }
        </>
        
    );
    };

    export default TestimonialSection;